function NewInput({
    label,
    name,
    type,
    placeholder,
    value,
    onChange,
    className,
    required,
    checked,
    readOnly,
}) {
    return (
        <div className={className}>
            <label htmlFor={name}>{label}</label>
            <input
                id={name}
                type={type}
                name={name}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                required={required}
                checked={checked}
                readOnly={readOnly}
            />
        </div>
    );
}

export default NewInput;
